import React from "react";

import Details from "./Details";
import Frame from "./Frame";
import ImageFrame from "./ImageFrame";
import LocationThumbnail from "./LocationThumbnail";

/**
 * Renders a card that highlights information about a location.
 */
const LocationTile = ({
  imageId,
  time,
  street,
  city,
  locationTimezone,
}: {
  /**
   * The id of the provider's cover iamge
   */
  imageId: string;
  /**
   * The time of the appointment (epoch ms)
   */
  time: number;
  /**
   * The street address (line1) of the relevant clinic location.
   */
  street: string;
  /**
   * The city of the relevant clinic location.
   */
  city: string;
  /**
   * The timezone of the relevant clinic location.
   */
  locationTimezone?: string | null;
}) => (
  <Frame>
    <ImageFrame>
      <LocationThumbnail imageId={imageId} />
    </ImageFrame>
    <Details time={time} locationTimezone={locationTimezone} line2={`${street}, ${city}`} />
  </Frame>
);

export default React.memo(LocationTile);
